var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageinline = function SvgImageinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.75c0-1.379 1.121-2.5 2.5-2.5h15c1.379 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15a2.502 2.502 0 0 1-2.5-2.5V5.75Zm12.648 4.16a.935.935 0 0 0-1.546 0l-3.399 4.985-1.035-1.293a.935.935 0 0 0-1.46 0l-2.501 3.125a.935.935 0 0 0 .73 1.523h13.126a.931.931 0 0 0 .828-.5.94.94 0 0 0-.055-.965L14.648 9.91ZM6.375 9.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
    fill: "#000"
  })));
};
export default SvgImageinline;